import { formatDistanceToNow } from "date-fns";
import { sv, enGB } from "date-fns/locale";
import React from "react";
import Box from "react-raster";
import { Heading } from "src/components";
import styled from "styled-components";
import { Text } from "src/components/text"
import { theme } from "src/config";
import { useTranslation } from "react-i18next";
import { IItem, ItemType } from "src/types";
import { inject, observer } from "mobx-react";
import { ItemStores } from "src/stores";

export type INextItemProps = {
  type:        ItemType;
  itemStores?: ItemStores;
};

export const NextItems = inject("itemStores")(observer((props: INextItemProps) => {

  const { type, itemStores } = props;
  const { t, i18n } = useTranslation();
  const locale = i18n.language == 'sv' ? sv : enGB;

  return (
    <Box display="flex" flexDirection="column" gap="1.5rem">
      <Heading color={theme.font.color.slate} type="h3">{t("next", { context: type })}</Heading>
      <Box cols={1} >
        <StyledTodoList>
          {itemStores[type].storage.next.getArray.slice(0, 2).map((i: IItem) => (
            <StyledTodoListItem key={i.id} onClick = {() => itemStores[type].setActiveById(i.id)}>
              <td>
              <Text weight="normal" as="a" color={"grayDarkest"} size="default">{type == 'deliverable' && (<strong>#{i.number}{ ' -  '}</strong>)}{i.title}</Text>
              </td>
              <td style={{paddingLeft: '0.875rem'}}>
                {(!!i.date) && ( 
                <Text size="small" color={theme.color.slate11}>
                  {formatDistanceToNow(i.date, {
                    addSuffix: true,
                    locale
                  })}
                </Text>
                )}
              </td>
            </StyledTodoListItem>
          ))}
          {(!itemStores[type].storage.next.getArray.length) && (<Text>{t("no_next", {context: type})}</Text>)}
        </StyledTodoList>
      </Box>
    </Box>
  );
}));

const StyledTodoList = styled.table`
  border-collapse: separate;
  border-spacing:  0rem 0.875rem;
`;

const StyledTodoListItem = styled.tr`
  font-size:       ${theme.font.size.small};
  cursor:          pointer;
`;